import OptionsNav from "pages/ManagementPage/OptionsNav/OptionsNav";

export default OptionsNav;
